import React, {FC} from 'react';
import {Icon, Approve} from '@optimaxdev/icons';
import {RequirementDataType} from '../register';
import s from './passwordRequirements.scss';

type PropsType = {
    requirementsData: RequirementDataType;
};

type RequirementType = {
    title: string;
    isValid: boolean;
};

export const REQUIRED_CHARS_IN_PASSWORD = 8;

/**
 * Getting password requirements data
 * @param {string} password - password value
 * @returns {RequirementDataType} - requirements data
 */
export const getPasswordRequirements = (password: string) => {
    return {
        touched: true,
        hasMinChars: password.length >= REQUIRED_CHARS_IN_PASSWORD,
        hasRepeatedChars:
            password.length >= 3 &&
            password
                .toLowerCase()
                .split('')
                .some(
                    (value, index) =>
                        password[index + 1] === value && password[index + 2] === value,
                ),
    };
};

/**
 * Password Requirements for Sign Up
 * @params {PropsTypes} PropsTypes - component types
 * @returns {JSX} react jsx
 */
export const PasswordRequirements: FC<PropsType> = ({requirementsData}) => {
    const requirements: RequirementType[] = [
        {
            title: `At least ${REQUIRED_CHARS_IN_PASSWORD} characters`,
            isValid: requirementsData.hasMinChars,
        },
        {
            title: 'No more than 2 repeating characters',
            isValid: !requirementsData.hasRepeatedChars,
        },
    ];

    return (
        <div className={s.passwordRequirements}>
            {requirements.map(({isValid, title}) => {
                const validRequirement = requirementsData.touched && isValid;

                return (
                    <p className={s.passwordRequirement} key={title}>
                        <span className={s.passwordRequirementIcon}>
                            {validRequirement ? (
                                <span className={s.checkIcon}>
                                    <Icon icon={Approve} />
                                </span>
                            ) : (
                                <div className={s.passwordRequirementDot} />
                            )}
                        </span>
                        {title}
                    </p>
                );
            })}
        </div>
    );
};
